import { Input as AntdInput, Dropdown } from 'antd'
import Flex from 'components/Flex'
import CalendarIcon from 'components/icons/CalendarIcon'
import FilterIcon from 'components/icons/FilterIcon'
import React from 'react'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
import { EmptySpan } from '../UIComponents/CommonStyledDiv'
export const FilterFlex = styled(Flex)`
  width: 50%;
`
export const FilterText = styled.p`
  margin-bottom: 0;
  margin-left: 10px;
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_60};
`
export const StyledDropdown = styled(Dropdown)`
  width: 100%;
  cursor: pointer;
  height: 50px;
  padding-left: 10px;
  border-left: ${props => (props?.bordered ? '1px' : '0px')} solid
    ${COLORS.GREY_T_90};
  border-right: ${props => (props?.bordered ? '1px' : '0px')} solid
    ${COLORS.GREY_T_90};
`
export const FlexWrap = styled(Flex)`
  width: ${props => (props?.width ? props?.width : '67%')};
  position: relative;
`
const randomString = Math.random().toString(36).substring(2, 7)
const AntdInputStyle = styled(AntdInput)`
  ::placeholder {
    font-size: 16px;
  }
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_BASE};
  color: ${COLORS.GREY_T_40};
  width: ${props => (props.width ? props.width : 'auto')};
  height: ${props => (props.height ? props.height : '48px')};
  padding-bottom: ${props => (props.padding ? props.padding : '3px')};
  border-radius: 8px;
  box-shadow: none;
  border-color: ${props => (props.error ? 'red' : '#e9e9e9')};
  :focus {
    border-color: #e9e9e9;
    box-shadow: none;
  }
  :hover {
    border-color: #e9e9e9;
  }
  :not(.ant-input-affix-wrapper-disabled):hover {
    border-color: #e9e9e9 !important;
  }
  .ant-input-affix-wrapper-focused {
    box-shadow: none;
    border-right-width: 0px !important;

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
`
const FilterDiv = ({
  overlayMenu,
  label = 'Filter',
  trigger = 'click',
  open = false,
  setOpen,
  onOpenChange,
  width,
  bordered = true,
  id = randomString,
  calendar = false,
  dateValue = '',
  required = false,
  rules,
  placeholder,
  DWidth,
  unsetRightBorder = false, // New prop to conditionally unset right border
  ...rest
}) => {
  return (
    <FlexWrap width={width} id={id}>
      <StyledDropdown
        overlay={overlayMenu}
        trigger={[trigger]}
        open={open}
        rules={rules}
        required={required}
        onClick={() => setOpen(true)}
        overlayStyle={{ width: DWidth ?? 'auto' }}
        onOpenChange={onOpenChange}
        getPopupContainer={trigger => trigger.parentNode}
        bordered={bordered}
        customStyles={
          unsetRightBorder ? 'none' : `1px solid ${COLORS.GREY_T_90}`
        }
        {...rest}
      >
        {calendar ? (
          <AntdInputStyle
            width={'150%'}
            value={dateValue}
            required={required}
            placeholder={placeholder}
            suffix={
              <EmptySpan
                style={{ paddingTop: '10px' }}
                onClick={() => setOpen(true)}
              >
                <CalendarIcon />
              </EmptySpan>
            }
          />
        ) : (
          <FilterFlex centerVertically onClick={e => e.preventDefault()}>
            <FilterIcon />
            <FilterText>{label}</FilterText>
          </FilterFlex>
        )}
      </StyledDropdown>
    </FlexWrap>
  )
}

export default FilterDiv
